
export enum RemarksTypes {
   BookingProgram,
   PendingBookingStatus,
   PendingPrepayStatus,
}


export enum BookingPostingErrorTypes {
   PrintFailure = "PrintFailed",
   PostingFailure = "PostingFailure",
   VoidFailure = "VoidFailure"
}

export enum ItemSearchType {
   SalesOrder = "SalesOrder",
   Booking = "Booking",
   Items = "Items"
}